import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import ListView from "../../../shared/components/listview/ListView";
import { EMPLOYEE_LEAVE_TYPE, ULTI_LEAVE_CODE } from "../../../shared/constants/Constants";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CREATENEW } from "../../../shared/constants/Constants";
import Modalpopup from "../../../shared/components/Modalpopup";
import { loadLeaveTypeDataRequest, loadLeaveTypeDeleteDataRequest } from "../redux/Actions";
import LeaveTypeAdd from "./LeaveTypeAdd";
import LeaveTypeEdit from "./LeaveTypeEdit";
import DeleteModal from "../../../shared/components/DeleteModal";
import Permissions from "../../../shared/components/Permissions";

const LeaveType = () => {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    let { leaveTypes, loading } = useSelector((state) => state.leaveType);
    let [selectedRow, setSelectedRow] = useState({})
    let [shouldReload,setShouldReload] = useState(true)

    useEffect(() => {
        if (shouldReload && !loading){
            dispatch(loadLeaveTypeDataRequest());
            setShouldReload(false);
        }
    }, [dispatch, shouldReload, loading]);

    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    let module_name = "Leave Type";
    let permission = Permissions(emp_no, module_name);

    let actionsPermission = !(permission.write_permission || permission.delete_permission);

    let columns = [
        {
            display_name: "id",
            field: "id",
            type: "number",
            hide: true
        },
        {
            display_name: EMPLOYEE_LEAVE_TYPE,
            field: "name",
            type: "text",
        },
        {
            display_name: ULTI_LEAVE_CODE,
            field: "ulti_leave_code",
            type: "text",
        },
        {
            display_name: "",
            field: 'actions',
            type: 'actions',
            hide: actionsPermission
        }
    ];

    const handleDelete = () => {
        dispatch(loadLeaveTypeDeleteDataRequest({ id: [selectedRow] }));
        setShouldReload(true);
        setShowDeleteModal(false);
    }

    let [clickEditFunc, setClickEditFunc] = useState(null);
    let [clickDeleteFunc, setClickDeleteFunc] = useState(null);
    useEffect(()=>{
        if (permission.write_permission){
            setClickEditFunc(
                () => (row)=>{
                setSelectedRow(row);
                setShowEditModal(true);
            })
        }
        if (permission.delete_permission){
            setClickDeleteFunc(
                () => (id)=>{
                setSelectedRow(id);
                setShowDeleteModal(true);
            })
        }
    },[permission])
    return (
        <>
            <Row>
                <Col className="gx-0">
                    <Breadcrumbs
                        children={[
                            { href: '/leave-type', label: EMPLOYEE_LEAVE_TYPE },
                        ]}
                    />
                </Col>
                <Col xs="auto" className="gx-0">
                    {permission.create_permission?(
                        <DefaultButton
                            buttonClass="btn btn-primary default-btn-color"
                            buttonTitle={CREATENEW}
                            actionBlock={() => setShowCreateModal(true)}
                        />
                    ):""}
                </Col>
            </Row>
            <Row>
                <Card>
                    <Card.Body>
                        <ListView
                            exportTitle={EMPLOYEE_LEAVE_TYPE}
                            columnNames={columns}
                            rowData={leaveTypes}
                            clickEdit={clickEditFunc}
                            clickDelete={clickDeleteFunc}
                        />
                    </Card.Body>
                </Card>
            </Row>
            <Modalpopup
                show={showCreateModal}
                handleClose={() => setShowCreateModal(false)}
                actionTitle={"Create " + EMPLOYEE_LEAVE_TYPE}
            >
                <LeaveTypeAdd
                    handleClose={(reload) => {
                        setShowCreateModal(false);
                        if (reload) {
                            dispatch(loadLeaveTypeDataRequest());
                        }
                    }}
                />
            </Modalpopup>
            <Modalpopup
                show={showEditModal}
                handleClose={() => { setShowEditModal(false) }}
                actionTitle={"Edit " + EMPLOYEE_LEAVE_TYPE}
            >
                <LeaveTypeEdit
                    leaveType={selectedRow}
                    handleClose={(reload) => {
                        if (reload) {
                            dispatch(loadLeaveTypeDataRequest());
                        }
                        setShowEditModal(false)
                    }}
                />
            </Modalpopup>
            <DeleteModal
                handleClose={() => { setShowDeleteModal(false) }}
                handleDelete={handleDelete}
                show={showDeleteModal}
            >
                <div>
                    Delete {EMPLOYEE_LEAVE_TYPE}?
                </div>
            </DeleteModal>
        </>
    );
};

export default LeaveType;
